/**
 * This reducer is used for validating products while adding to cart
 */
import {
    VALIDATE_PRODUCTS,
    VALIDATE_PRODUCTS_SUCCESS,
    VALIDATE_PRODUCTS_FAILURE,
    CLEAR_VALIDATED_PRODUCTS,
} from '../actions/actionTypes';

const initialState = {
    validatedProducts: [],
    loadingStatusArray: [],
    loading: false,
    statusCode: 0,
    statusMessage: '',
    accountError:'',
    surgeonError:'',
};

const consignmentAddValidateProductsReducer = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case VALIDATE_PRODUCTS:
            return {
                ...state,
                validatedProducts: [], 
                loadingStatusArray: Array.isArray(action?.payload?.products)
                    ? action.payload.products.map((product) => ({
                          cfn: product?.cfn,
                          salesOrg: product?.salesOrg,
                          loading: true,
                      }))
                    : [],
                loading: true,
                statusCode: 0,
            };
        case VALIDATE_PRODUCTS_SUCCESS:
            return {
                ...state,
                validatedProducts: [...action.validatedProducts],
                loadingStatusArray: initialState.loadingStatusArray,
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
                accountError: action.accountError,
                surgeonError: action.surgeonError,
            };
        case VALIDATE_PRODUCTS_FAILURE:
            return {
                ...state,
                validatedProducts: [],
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loadingStatusArray: initialState.loadingStatusArray,
                loading: false,
            };
        case CLEAR_VALIDATED_PRODUCTS:
            return {
                ...state,
                validatedProducts: [],
                statusCode: initialState.statusCode,
                statusMessage: initialState.statusMessage,
                accountError: initialState.accountError,
                surgeonError: initialState.surgeonError,
                loadingStatusArray: initialState.loadingStatusArray,
            };

        default: {
            return { ...state };
        }
    }
};

export default consignmentAddValidateProductsReducer;
